// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.c-circular-progress[data-v-018760aa] {\n  height: 100%;\n  width: 100%;\n}\n.c-rings[data-v-018760aa] {\n  height: 100%;\n  width: 100%;\n}\n.c-logo-container[data-v-018760aa] {\n  border-radius: 50%;\n}\n.c-logo[data-v-018760aa] {\n  border-radius: 50%;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
